import axios from "../utils/ajaxRequest";

export const cardioDetail = (params) => axios.request({
    url: '/share/cardioDetail',
    method: 'POST',
    data: params
});

export default {
    cardioDetail
};